const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  centred: {
    width: '100%',
    maxWidth: '1320px',
    alignSelf:'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  flex: {
    flex: 1,
    fontWeight: 300,
    fontSize: 15,
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
})

export default styles
